<template>
  <div class="ticket-qr">
    <div class="container">
      <h2 class="page-title">Kod QR biletu</h2>
      <div class="data">
        <div class="description">
          <span>Numer biletu: {{ ticketData.id }}</span>
        </div>
        <img :src="getImageSrc" alt="Kod QR biletu">
      </div>
      <div class="back-button">
        <button
          type="button"
          class="back-to-tickets"
          title="Wróć do listy biletów"
          @click="backToTickets"
        >
          <i class="fas fa-chevron-circle-left"></i>Wróć do listy biletów
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TicketQR',
  props: {
    QRData: {
      required: true,
    },
    ticketData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getImageSrc() {
      return `data:image/png;base64,${this.QRData}`;
    },
  },
  methods: {
    backToTickets() {
      this.$emit('backToTickets');
    },
  },
};
</script>

<style scoped>
.page-title {
  padding-bottom: 30px;
}

.data,
.back-button {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
}

.data .description {
  margin-bottom: 15px;
}

.back-button {
  padding: 30px 0;
}
</style>
